import { business } from "../data/site";
import type { FaqItem } from "../types/content";

type Crumb = {
  name: string;
  path: string;
};

type ServiceInput = {
  name: string;
  description: string;
  path: string;
  serviceType: string;
  brandName: string;
  brandUrl: string;
};

const businessId = `${business.url}#business`;

export function absoluteUrl(path: string) {
  return new URL(path, business.url).toString();
}

export function businessSchema() {
  return {
    "@type": "HVACBusiness",
    "@id": businessId,
    name: business.name,
    url: business.url,
    telephone: "+61 8 9228 3555",
    areaServed: { "@type": "City", name: "Perth" },
    address: {
      "@type": "PostalAddress",
      addressLocality: "Perth",
      addressRegion: "WA",
      addressCountry: "AU",
    },
    knowsAbout: [
      "Rinnai ducted air conditioning",
      "Rinnai split system air conditioning",
      "Rinnai multi-split air conditioning",
      "iZone smart climate control",
      "Residential heat load calculation",
    ],
  };
}

export function faqSchema(items: FaqItem[]) {
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };
}

export function breadcrumbSchema(crumbs: Crumb[]) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: absoluteUrl(crumb.path),
    })),
  };
}

export function serviceSchema({ name, description, path, serviceType, brandName, brandUrl }: ServiceInput) {
  return {
    "@type": "Service",
    name,
    description,
    serviceType,
    url: absoluteUrl(path),
    provider: { "@id": businessId },
    areaServed: { "@type": "City", name: "Perth" },
    brand: { "@type": "Brand", name: brandName, url: brandUrl },
  };
}
